import type { Application } from '~entities/application';

export const applicationInProgressMock: Application = {
  id: 'demo_id',
  qualified: false,
  applicationStatus: 'IN_PROGRESS',
  formFillingStatus: 'FINISHED',
  applicationStatusChangedUTC: new Date().toUTCString(),
};
